import YFormMobile from './Mobile';

export { YFormMobile };
export default YFormMobile;
